/**
 * championLobbyCatalog — OCP lobby display metadata for selectable champs.
 */
const catalog = new Map();

export function registerChampionLobbyDetails(champId, details) {
  catalog.set(String(champId).toLowerCase(), details);
}

export function getChampionLobbyDetails(champId) {
  return catalog.get(String(champId || '').toLowerCase()) || {
    name: champId || 'Unknown',
    title: 'Campeón',
    icon: '',
    abilities: []
  };
}

export function listLobbyChampionIds() {
  return [...catalog.keys()];
}

registerChampionLobbyDetails('ashe', {
  name: 'Ashe',
  title: 'La Arquera de Hielo',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Ashe.png',
  abilities: [
    { slot: 'P', name: 'Tiro Congelador', desc: 'Aplica ralentización con ataques básicos.' },
    { slot: 'Q', name: 'Concentración del Guardián', desc: 'Aumenta la velocidad de ataque.' },
    { slot: 'W', name: 'Descarga de Flechas', desc: 'Dispara 7 flechas en abanico.' },
    { slot: 'E', name: 'Disparo de Halcón', desc: 'Revela el mapa en línea recta.' },
    { slot: 'R', name: 'Flecha de Cristal Encantada', desc: 'Flecha global que aturde.' }
  ]
});

registerChampionLobbyDetails('garen', {
  name: 'Garen',
  title: 'El Poder de Demacia',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Garen.png',
  abilities: [
    { slot: 'P', name: 'Perseverancia', desc: 'Regeneración masiva de vida fuera de combate.' },
    { slot: 'Q', name: 'Golpe Decisivo', desc: 'Silencia al enemigo e incrementa velocidad.' },
    { slot: 'W', name: 'Coraje', desc: 'Escudo defensivo y reducción de daño.' },
    { slot: 'E', name: 'Juicio', desc: 'Gira su espada infligiendo daño continuo.' },
    { slot: 'R', name: 'Justicia Demacia', desc: 'Espada celestial que inflige daño verdadero.' }
  ]
});

registerChampionLobbyDetails('ryze', {
  name: 'Ryze',
  title: 'El Mago Rúnico',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Ryze.png',
  abilities: [
    { slot: 'P', name: 'Maestría Arcana', desc: 'El maná máximo incrementa el daño del hechizo.' },
    { slot: 'Q', name: 'Descarga Sobrecargada', desc: 'Disparo mágico de daño en línea recta.' },
    { slot: 'W', name: 'Prisión Rúnica', desc: 'Inmoviliza al objetivo infligiendo daño.' },
    { slot: 'E', name: 'Flujo de Hechizos', desc: 'Proyectil rebotante entre enemigos.' },
    { slot: 'R', name: 'Poder Desesperado', desc: 'Potencia velocidad y otorga succion de hechizo.' }
  ]
});

registerChampionLobbyDetails('annie', {
  name: 'Annie',
  title: 'La Niña Oscura',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Annie.png',
  abilities: [
    { slot: 'Q', name: 'Desintegrar', desc: 'Orbe mágico al objetivo; aturde si lo mata.' },
    { slot: 'W', name: 'Incinerar', desc: 'Cono de fuego mágico.' },
    { slot: 'R', name: 'Invocar: Tibbers', desc: 'Invoca daño y aturdimiento en área.' }
  ]
});

registerChampionLobbyDetails('sivir', {
  name: 'Sivir',
  title: 'La Señora de la Batalla',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Sivir.png',
  abilities: [
    { slot: 'Q', name: 'Hoja Bumerán', desc: 'Proyectil físico de largo alcance.' },
    { slot: 'E', name: 'Escudo de Hechizos', desc: 'Bloquea el próximo efecto hostil.' },
    { slot: 'R', name: 'A la Caza', desc: 'Aumenta la velocidad de movimiento.' }
  ]
});

registerChampionLobbyDetails('lux', {
  name: 'Lux',
  title: 'La Dama de la Luminosidad',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Lux.png',
  abilities: [
    { slot: 'Q', name: 'Atadura de Luz', desc: 'Proyectil que inmoviliza.' },
    { slot: 'W', name: 'Barrera Prismática', desc: 'Escudo de luz.' },
    { slot: 'E', name: 'Singularidad Lucente', desc: 'Zona que ralentiza.' },
    { slot: 'R', name: 'Chispa Final', desc: 'Rayo de largo alcance.' }
  ]
});

registerChampionLobbyDetails('brand', {
  name: 'Brand',
  title: 'La Venganza Ardiente',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Brand.png',
  abilities: [
    { slot: 'Q', name: 'Quemar', desc: 'Orbe de fuego al objetivo.' },
    { slot: 'W', name: 'Pilar de Llamas', desc: 'Área de fuego.' },
    { slot: 'E', name: 'Conflagración', desc: 'Propagación de fuego.' },
    { slot: 'R', name: 'Piroclasma', desc: 'Rebotes de fuego.' }
  ]
});

registerChampionLobbyDetails('veigar', {
  name: 'Veigar',
  title: 'El Pequeño Maestro del Mal',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Veigar.png',
  abilities: [
    { slot: 'Q', name: 'Golpe Funesto', desc: 'Proyectil de energía oscura.' },
    { slot: 'W', name: 'Materia Oscura', desc: 'Impacto en área.' },
    { slot: 'E', name: 'Horizonte de Sucesos', desc: 'Anillo que aturde.' },
    { slot: 'R', name: 'Estallido Primordial', desc: 'Ejecución mágica.' }
  ]
});

registerChampionLobbyDetails('soraka', {
  name: 'Soraka',
  title: 'La Hija de las Estrellas',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Soraka.png',
  abilities: [
    { slot: 'Q', name: 'Llamada Estelar', desc: 'Área que ralentiza y regenera.' },
    { slot: 'W', name: 'Infusión Astral', desc: 'Cura a un aliado.' },
    { slot: 'E', name: 'Equinoccio', desc: 'Zona de silencio y root.' },
    { slot: 'R', name: 'Deseo', desc: 'Cura global al equipo.' }
  ]
});

registerChampionLobbyDetails('lulu', {
  name: 'Lulu',
  title: 'La Maga Hechicera',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Lulu.png',
  abilities: [
    { slot: 'Q', name: 'Lanza Brillante', desc: 'Proyectil que ralentiza.' },
    { slot: 'W', name: 'Capricho', desc: 'Acelera el movimiento.' },
    { slot: 'E', name: '¡Ayuda, Pix!', desc: 'Escudo aliado.' },
    { slot: 'R', name: 'Crecimiento Descomunal', desc: 'Knockup y vida extra.' }
  ]
});

registerChampionLobbyDetails('nami', {
  name: 'Nami',
  title: 'La Invocadora de Mareas',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Nami.png',
  abilities: [
    { slot: 'Q', name: 'Prisión Acuática', desc: 'Área que aturde.' },
    { slot: 'W', name: 'Flujo y Reflujo', desc: 'Cura o daño en rebote.' },
    { slot: 'E', name: 'Bendición de la Marejada', desc: 'Buff de marea.' },
    { slot: 'R', name: 'Oleada Marina', desc: 'Ola de largo alcance.' }
  ]
});

registerChampionLobbyDetails('ezreal', {
  name: 'Ezreal',
  title: 'El Explorador Pródigo',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Ezreal.png',
  abilities: [
    { slot: 'Q', name: 'Disparo Místico', desc: 'Proyectil físico de largo alcance.' },
    { slot: 'W', name: 'Flujo Esencial', desc: 'Buff de movimiento.' },
    { slot: 'E', name: 'Cambio Arcano', desc: 'Parpadeo corto.' },
    { slot: 'R', name: 'Descarga Certera', desc: 'Rayo global.' }
  ]
});

registerChampionLobbyDetails('caitlyn', {
  name: 'Caitlyn',
  title: 'La Sheriff de Piltover',
  icon: 'https://ddragon.leagueoflegends.com/cdn/13.24.1/img/champion/Caitlyn.png',
  abilities: [
    { slot: 'Q', name: 'Pacificadora de Piltover', desc: 'Disparo lineal.' },
    { slot: 'W', name: 'Trampa Yordle', desc: 'Coloca una trampa.' },
    { slot: 'E', name: 'Red de 90 Calibre', desc: 'Red y retroceso.' },
    { slot: 'R', name: 'As en la Manga', desc: 'Disparo al objetivo.' }
  ]
});
